export default "__VITE_ASSET__7d6df6ce__$_?inline__"